import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

function Layout({ children }: Props) {
  return <div>{children}</div>;
}

export { Layout };
